import equal from "fast-deep-equal";

import articleTypes from "../../articles/constants/articleTypes";
import contributorRoles from "../../articles/constants/contributorRoles";
import updateArticle from "../../articles/updateArticle";

import { WorkMetaData } from "../types/WorkMetaData";

export function syncWorkArticleData(firebase, { work, articles, data, transaction, user }) {
	const metaDataBefore = WorkMetaData.partial().safeParse(work).data || work;
	const metaDataAfter = data ? WorkMetaData.partial().parse(data) : {};

	const updatedKeys = Object.keys(metaDataAfter).filter((key) => !equal(metaDataBefore[key], metaDataAfter[key]));

	if (updatedKeys.length > 0) {
		return Promise.all(
			articles.map((article) => {
				const data = updatedKeys
					.filter((key) => {
						return shouldUpdateKey(key, article, metaDataBefore);
					})
					.reduce(
						(acc, key) => ({
							...acc,
							[key]: transformValue(key, metaDataAfter[key], article),
						}),
						{},
					);

				return updateArticle(firebase, { ref: article.ref, ...data }, { transaction, user });
			}),
		);
	}
}

export function shouldUpdateKey(key, article, work) {
	return equal(compareValue(key, article[key], article), compareValue(key, work[key], article));
}

function compareValue(key, value, article) {
	const transformed = transformValue(key, value, article);

	return key === "contributors" ? transformed?.slice().sort((a, b) => a.role.localeCompare(b.role)) : transformed;
}

export function transformValue(key, value, article) {
	if (key === "bokgruppe" && typeof value === "string") {
		const digit = article.type === articleTypes.EBOOK ? "5" : "8";

		return value.replace("x", digit);
	}

	if (key === "contributors" && article?.type === articleTypes.EBOOK) {
		return value?.filter((contributor) => contributor.role !== contributorRoles.NARRATOR);
	}

	return value;
}
